var GenericErrorSkipRules = {
    'findCustomers': ['*'],
    'createAppointment': ['*'],
    'decodeVin': ['*'],
    'matchCustomer': ['*']
};

module.exports = GenericErrorSkipRules;